import { Box, Stack, Typography } from "@mui/material";
import ImagePreview from "../../../Common/UI/ImagePreview";
import { useState } from "react";

type Props = {
  currentBlock: any;
};

const PictureField = ({ currentBlock }: Props) => {
  const position = currentBlock?.config?.position;
  const label = currentBlock?.label;
  const signedResourceUrl = currentBlock?.signedResourceUrl;
  const [showImagePreview, setImagePreview] = useState(false);
  const toggleImagePreview = () => {
    setImagePreview((prev) => !prev);
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItem: "center",
          justifyContent:
            position === "left"
              ? "flex-start"
              : position === "right"
              ? "flex-end"
              : "center",
        }}
      >
        <Stack gap={0.5}>
          {label && (
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 500,
                color: "text.primary",
              }}
            >
              {label}
            </Typography>
          )}
          {signedResourceUrl && (
            <Box
              sx={{
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={toggleImagePreview}
            >
              <img
                src={signedResourceUrl}
                alt="preview"
                style={{
                  maxHeight: "200px",
                  maxWidth: "200px",
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
            </Box>
          )}
        </Stack>
      </Box>

      {showImagePreview && (
        <ImagePreview
          closeHandler={toggleImagePreview}
          image={signedResourceUrl || ""}
        />
      )}
    </>
  );
};
export default PictureField;
